import classNames from "gpages/utils/classnames"
import React from "react"
import * as styles from "./container.module.scss"

const Container = ({ children, className }) => {
  return (
    <div className={classNames(styles.container, className)}>{children}</div>
  )
}

export default Container
